import React from "react"
import { Grid } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import {
  PromotionalFooterPure,
  Container,
  Stepper,
  HeaderHLPure,
  SimpleLoading,
} from "../../pures"

import "./sign-request-by-volume.view.css"

const SignRequestByVolumeView = (props) => {
  const { t } = useTranslation()
  const { steps, stepMetadata, selectedStep, loading } = props
  const step = steps[selectedStep];
  const {
    component: StepComponent,
    back,
    next,
    load,
    send,
  } = stepMetadata[selectedStep];
  const title = `${step.title}.`;
  const subtitle = `
  ${t("configurationPlanRenovationView.steps")} ${selectedStep + 1} 
  ${t("configurationPlanRenovationView.of")} ${steps.length}
`;
  const instruction = `${step.instruction}`;

  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <HeaderHLPure title={t("signRequestByVolume.title")} />
        </Grid>
        <Grid item xs={12}>
          <Stepper
            steps={steps}
            selectedStep={selectedStep}
            title={title}
            subtitle={subtitle}
            instruction={instruction}
          />
        </Grid>
        <Grid item xs={12} className="container-step-sigatureRequestProfile">
          {loading ? (
            <div className="step-description-sigatureRequestProfile">
              <SimpleLoading />
            </div>
          ) : (
            <StepComponent
              step={step}
              onHandleNext={next}
              onHandleBack={back}
              onHandleLoad={load}
              onSendToSign={send}
              {...props}
            />
          )}
        </Grid>
        <Grid item xs={12}>
          <PromotionalFooterPure />
        </Grid>
      </Grid>
    </Container>
  );
};

export default SignRequestByVolumeView;
